export const EVENT_ACTIVITY_INDEX_REQUEST = 'EVENT_ACTIVITY_INDEX_REQUEST';
export const EVENT_ACTIVITY_INDEX_SUCCESS = 'EVENT_ACTIVITY_INDEX_SUCCESS';
export const EVENT_ACTIVITY_INDEX_FAILURE = 'EVENT_ACTIVITY_INDEX_FAILURE';

export const EVENT_ACTIVITY_DOWNLOAD_REQUEST = 'EVENT_ACTIVITY_DOWNLOAD_REQUEST';
export const EVENT_ACTIVITY_DOWNLOAD_SUCCESS = 'EVENT_ACTIVITY_DOWNLOAD_SUCCESS';
export const EVENT_ACTIVITY_DOWNLOAD_FAILURE = 'EVENT_ACTIVITY_DOWNLOAD_FAILURE';
